<template>
  <list-project :author="data" />
</template>

<script>
// import ListProject from '@/views/admin/projects/ListProject'

export default {
  computed: {
    clientId() {
      return this.$route.params.id
    },
    data() {
      return this.$store.state.client.data[this.clientId]
    }
  },
  // components: { ListProject }
}
</script>
